import React from "react";

interface Props {
  className?: string;
}

export const PauseIconComponent: React.SFC<Props> = ({ className }) => {
  return (
    // tslint:disable:max-line-length
    <svg width="100%" height="100%" viewBox="0 0 14 22" xmlns="http://www.w3.org/2000/svg" className={className || ""}>
      <path d="M0 0H4V22H0V0Z" />
      <path d="M10 0H14V22H10V0Z" />
    </svg>
    // tslint:enable:max-line-length
  );
};
